export enum HighCommissionBoosting {
  NAME = 'plp_hc_boosting',
  OFF = 'off',
  ON = 'on',
}

export enum ClpPopulation {
  AUTO = 'auto',
  NAME = 'clp_population',
  QUERY = 'query',
}

export enum ProductCardDiscountAmount {
  NAME = 'plp_productcard_discount_amount',
  NOT_SHOWN = 'not_shown',
  SHOWN = 'shown',
}
